/**
 * 동적 라우팅 설정 파일
 * 메뉴별로 여러 버전의 컴포넌트를 관리
 * - 다른 버전: proId에 따라 추가 가능
 */

import M_TBG_BASICF from '../Scripts/TBMManager/M_TBG_BASIC/M_TBG_BASICF';
import M_TBG_CUSTOMF from '../Scripts/TBMManager/M_TBG_CUSTOM/M_TBG_CUSTOM/M_TBG_CUSTOMF';
import M_FILE_BASICF from '../Scripts/File/M_FILE_BASIC/M_FILE_BASIC/M_FILE_BASICF';
import M_FILE_CUSTOMF from '../Scripts/File/M_FILE_CUSTOM/M_FILE_CUSTOM/M_FILE_CUSTOMF';
import M_PER_CUSTOMF from '../Scripts/Permit/M_PER_CUSTOM/M_PER_CUSTOM/M_PER_CUSTOMF';
import M_PER_CUSTOM_01F from '../Scripts/Permit/M_PER_CUSTOM/M_PER_CUSTOM_01/M_PER_CUSTOM_01F';
import M_PER_CUSTOM_02F from '../Scripts/Permit/M_PER_CUSTOM/M_PER_CUSTOM_02/M_PER_CUSTOM_02F';
import M_TBM_BASICF from '../Scripts/TBM/M_TBM_BASIC/M_TBM_BASICF';
import M_TBM_CUSTOMF from '../Scripts/TBM/M_TBM_CUSTOM/M_TBM_CUSTOM/M_TBM_CUSTOMF';
//#region 교육자료
import M_TRA_BASICF from '../Scripts/Training/TrainingPage/M_TRA_BASIC/M_TRA_BASIC/M_TRA_BASICF'; // 관리자용 교육자료(리스트)
import M_TRA_BASIC_01F from '../Scripts/Training/TrainingPage/M_TRA_BASIC/M_TRA_BASIC_01/M_TRA_BASIC_01F'; // 관리자용 교육자료(pdf)
import M_TRA_BASIC_02F from '../Scripts/Training/TrainingPage/M_TRA_BASIC/M_TRA_BASIC_02/M_TRA_BASIC_02F'; // 관리자용 교육자료(동영상)
import M_TRA_BASIC_03F from '../Scripts/Training/TrainingPage/M_TRA_BASIC/M_TRA_BASIC_03/M_TRA_BASIC_03F'; // 관리자용 교육자료(등록)
import M_TRA_CUSTOMF from '../Scripts/Training/TrainingPage/M_TRA_CUSTOM/M_TRA_CUSTOM/M_TRA_CUSTOMF'; // 관리자용 교육자료(리스트)
import M_TRA_CUSTOM_01F from '../Scripts/Training/TrainingPage/M_TRA_CUSTOM/M_TRA_CUSTOM_01/M_TRA_CUSTOM_01F'; // 관리자용 교육자료(pdf)
import M_TRA_CUSTOM_02F from '../Scripts/Training/TrainingPage/M_TRA_CUSTOM/M_TRA_CUSTOM_02/M_TRA_CUSTOM_02F'; // 관리자용 교육자료(동영상)
import M_TRA_CUSTOM_03F from '../Scripts/Training/TrainingPage/M_TRA_CUSTOM/M_TRA_CUSTOM_03/M_TRA_CUSTOM_03F'; // 관리자용 교육자료(등록)
import M_PER_BASICF from './../Scripts/Permit/M_PER_BASIC/M_PER_BASIC/M_PER_BASICF';
import M_PER_BASIC_01F from './../Scripts/Permit/M_PER_BASIC/M_PER_BASIC_01/M_PER_BASIC_01F';
import M_PER_BASIC_02F from './../Scripts/Permit/M_PER_BASIC/M_PER_BASIC_02/M_PER_BASIC_02F';
import M_PER_NEWF from './../Scripts/PermitNew/M_PER_NEW/M_PER_NEW/M_PER_NEWF';
import M_PER_NEW_01F from './../Scripts/PermitNew/M_PER_NEW/M_PER_NEW_01/M_PER_NEW_01F';
import M_PER_NEW_02F from './../Scripts/PermitNew/M_PER_NEW/M_PER_NEW_02/M_PER_NEW_02F';
import M_PER_NEW_03F from './../Scripts/PermitNew/M_PER_NEW/M_PER_NEW_03/M_PER_NEW_03F';
import M_Master_BASICF from '../Scripts/ToolBoxMeeting/BASIC/Master/M_Master_BASICF';
import M_Master_HANF from '../Scripts/ToolBoxMeeting/HAN/Master/M_Master_BASICF';
import M_TBS_CUSTOMF from '../Scripts/TBMSetting/M_TBS_CUSTOM/M_TBS_CUSTOM/M_TBS_CUSTOMF';
import M_TBS_HANF from '../Scripts/TBMSetting/HAN/M_TBS_CUSTOM/M_TBS_CUSTOMF';
import M_RNM_DAI_01F from '../Scripts/RiskNearMiss/M_RNM_DAI/M_RNM_DAI_01/M_RNM_DAI_01F';
import M_RNM_BASIC_03F from '../Scripts/RiskNearMiss/M_RNM_BASIC_03/M_RNM_BASIC_03F';
import M_RNM_DAI_03F from '../Scripts/RiskNearMiss/M_RNM_DAI/M_RNM_DAI_03/M_RNM_DAI_03F';
import M_RNM_DAI_02F from '../Scripts/RiskNearMiss/M_RNM_DAI/M_RNM_DAI_02/M_RNM_DAI_02F';
import M_RNM_DAIF from '../Scripts/RiskNearMiss/M_RNM_DAI/M_RNM_DAI/M_RNM_DAIF';
import M_RNM_BASICF from '../Scripts/RiskNearMiss/M_RNM_BASIC/M_RNM_BASICF';
import M_RNM_BASIC_01F from '../Scripts/RiskNearMiss/M_RNM_BASIC_01/M_RNM_BASIC_01F';
import M_RNM_BASIC_02F from '../Scripts/RiskNearMiss/M_RNM_BASIC_02/M_RNM_BASIC_02F';
import M_WOR_BASICF from '../Scripts/WorkInfo/M_WOR_BASIC/WOR_BASICF';
import M_WOR_BASIC_01F from '../Scripts/WorkInfo/M_WOR_BASIC_01/WOR_BASIC_01F';
import M_WOR_BASIC_02F from '../Scripts/WorkInfo/M_WOR_BASIC_02/WOR_BASIC_02F';
import M_WOR_BASIC_03F from '../Scripts/WorkInfo/M_WOR_BASIC_03/WOR_BASIC_03F';
import M_WOR_DAI_01F from '../Scripts/WorkInfo/M_WOR_DAI/M_WOR_DAI_01/WOR_DAI_01F';
import M_WOR_DAI_02F from '../Scripts/WorkInfo/M_WOR_DAI/M_WOR_DAI_02/WOR_DAI_02F';
import M_WOR_DAI_03F from '../Scripts/WorkInfo/M_WOR_DAI/M_WOR_DAI_03/WOR_DAI_03F';
import M_WOR_DAIF from '../Scripts/WorkInfo/M_WOR_DAI/M_WOR_DAI/WOR_DAIF';
//#endregion

/**
 * 라우트 설정
 * key: 메뉴 ID
 * value: {
 *   [path]: {
 *     default: 기본 컴포넌트,
 *     [proId]: 해당 proId일 때 사용할 컴포넌트,
 *     ...
 *   }
 * }
 */
export const routeConfig = {
  // 작업허가서
  M_Permit: {
    list: {
      default: M_PER_BASICF,
      M_PER_CUSTOM: M_PER_CUSTOMF,
      M_PER_NEW: M_PER_NEWF,
    },
    write: {
      default: M_PER_BASIC_01F,
      M_PER_CUSTOM: M_PER_CUSTOM_01F,
      M_PER_NEW: M_PER_NEW_01F,
    },
    detail: {
      default: M_PER_BASIC_02F,
      M_PER_CUSTOM: M_PER_CUSTOM_02F,
      M_PER_NEW: M_PER_NEW_02F,
    },
    extand: {
      M_PER_NEW: M_PER_NEW_03F,
    },
  },

  M_RNM: {
    list: {
      default: M_RNM_BASICF,
      M_RNM_DAI: M_RNM_DAIF,
    },
    choose: {
      default: M_RNM_BASIC_01F,
      M_RNM_DAI: M_RNM_DAI_01F,
    },
    write: {
      default: M_RNM_BASIC_02F,
      M_RNM_DAI: M_RNM_DAI_02F,
    },
    action: {
      default: M_RNM_BASIC_03F,
      M_RNM_DAI: M_RNM_DAI_03F,
    },
  },

  M_WorkInfo: {
    list: {
      default: M_WOR_BASICF,
      M_WOI_DAI: M_WOR_DAIF,
    },
    choose: {
      default: M_WOR_BASIC_01F,
      M_WOI_DAI: M_WOR_DAI_01F,
    },
    write: {
      default: M_WOR_BASIC_02F,
      M_WOI_DAI: M_WOR_DAI_02F,
    },
    action: {
      default: M_WOR_BASIC_03F,
      M_WOI_DAI: M_WOR_DAI_03F,
    },
  },

  // TBM
  M_TBMManager: {
    // 교육 진행자(쓰기)
    write: {
      default: M_TBG_BASICF,
      M_TBG_CUSTOM: M_TBG_CUSTOMF,
      M_TBM_NEW_01: M_Master_BASICF,
      M_TBM_HAN_01: M_Master_HANF,
    },
    // TBM 교육 설정(자료 선택)
    setting: {
      default: M_TBS_CUSTOMF,
      M_TBM_HAN_01: M_TBS_HANF,
    },
  },

  M_TBM: {
    // 교육 받는 근로자(조회)
    list: {
      default: M_TBM_BASICF,
      M_TBM_CUSTOM: M_TBM_CUSTOMF,
      M_TBM_NEW_02: M_Master_BASICF,
      M_TBM_HAN_02: M_Master_HANF,
    },
  },

  // 교육 파일
  M_File: {
    list: {
      default: M_FILE_BASICF,
      M_FILE_CUSTOM: M_FILE_CUSTOMF,
    },
  },

  // 교육자료
  M_TrainingPage: {
    list: {
      default: M_TRA_BASICF,
      M_TRA_CUSTOM: M_TRA_CUSTOMF,
    },
    edu: {
      default: M_TRA_BASIC_01F,
      M_TRA_CUSTOM: M_TRA_CUSTOM_01F,
    },
    video: {
      default: M_TRA_BASIC_02F,
      M_TRA_CUSTOM: M_TRA_CUSTOM_02F,
    },
    write: {
      default: M_TRA_BASIC_03F,
      M_TRA_CUSTOM: M_TRA_CUSTOM_03F,
    },
  },

  // 다른 메뉴도 동일한 방식으로 추가 가능
  // M_Notice: {
  //   list: {
  //     default: M_NOT_BASICF,
  //     M_NOT_CUSTOM: M_NOT_CUSTOMF,
  //   },
  // },
};

/**
 * 메뉴 ID와 경로로 컴포넌트를 가져오는 헬퍼 함수
 */
export function getComponent(menuId, path) {
  const menuConfig = routeConfig[menuId];
  if (!menuConfig) {
    console.warn(`라우트 설정을 찾을 수 없습니다: ${menuId}`);
    return null;
  }

  const pathConfig = menuConfig[path];
  if (!pathConfig) {
    console.warn(`경로 설정을 찾을 수 없습니다: ${menuId}/${path}`);
    return null;
  }

  return pathConfig;
}
